var cssClassIdx = 0;
export function getClassId() {
    return cssClassIdx++;
}



//////////////////
// WEBPACK FOOTER
// ./~/echarts/~/zrender/lib/svg/cssClassId.js
// module id = 648
// module chunks = 1